import { z } from 'zod'

export const prospectFormSchema = z.object({
  firstName: z.string().nonempty(),
  lastName: z.string().nonempty(),
  email: z.string().email(),
  resume: z.array(z.instanceof(File)).min(1),
  department: z.string().nonempty(),
})

export type ProspectFormValues = z.infer<typeof prospectFormSchema>

export interface ProspectFormSectionData {
  className?: string
  title: string
  subtitle?: string
  image: {
    src: string
    alt: string
  } | null
  successTitle: string
  successSubtitle: string
  successButtonText: string
  departments: { handle: string; name: string; greenhouse_ids: string[] }[]
}
